import Button from "~/components/ui/Button"

import { CreditCardIcon } from "@heroicons/react/24/solid"
import { useTakePaymentButton } from "./useTakePaymentButton"
type Props = {
  total_owed: string
}
export const TakePaymentButton: React.FC<Props> = (props) => {
  const { total_owed } = props
  const { handleAcceptPayment } = useTakePaymentButton({ total_owed })
  return (
    <>
      <Button
        variant="white"
        size="small"
        shadow="small"
        className="flex items-center text-gray-600 mr-2"
        onClick={handleAcceptPayment}
        dataTestId="take-payment-button"
      >
        <CreditCardIcon className="w-5 h-5 text-gray-700 mr-2" />
        <div className="hidden sm:block">Take payment</div>
        <div className="sm:hidden">Pay</div>
      </Button>
    </>
  )
}
